module.exports = __webpack_public_path__ + "img/FSBS_big sword v2.1d590fa0.png";